import { motion } from "framer-motion";

const Star = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path d="M12 2l2.6 6.4 6.9.5-5.3 4.4 1.7 6.7L12 16.3 6.1 20l1.7-6.7L2.5 8.9l6.9-.5z" fill="currentColor" strokeLinejoin="round" />
  </svg>
);

export const Cloud = ({ className }) => (
  <svg viewBox="0 0 200 100" className={className} aria-hidden="true">
    <path d="M50 85 C20 85 10 60 30 50 C25 25 60 15 75 35 C85 10 130 10 135 40 C160 30 185 50 170 70 C185 85 165 90 150 85 Z" fill="currentColor" />
  </svg>
);

export const Sparkle = ({ className }) => <Star className={`twinkle ${className}`} />;

export const Wave = () => (
  <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="absolute bottom-0 left-0 h-12 w-full sm:h-16" aria-hidden="true">
    <path d="M0 40 C240 90 480 0 720 30 C960 60 1200 10 1440 40 L1440 80 L0 80 Z" fill="#ffffff" />
  </svg>
);

export const SectionTitle = ({ title, subtitle, id }) => (
  <Reveal className="mb-10 sm:mb-12">
    {subtitle && (
      <div className="flex items-center gap-2 text-pink-500">
        <Star className="h-5 w-5" />
        <span className="text-xs font-semibold uppercase tracking-[0.2em]">{subtitle}</span>
      </div>
    )}
    <h2 data-testid={`${id}-section-title`} className="font-display mt-2 text-3xl font-semibold text-blue-900 sm:text-4xl">
      {title}
    </h2>
  </Reveal>
);

export const Reveal = ({ children, className = "", delay = 0, as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </M>
  );
};
